import React from "react";
import classnames from "classnames";

type Props = {
  type?: string;
};

const getText = (type: string): string => {
  switch (type) {
    case "invalid":
      return "Invalid URL";
    case "loading":
      return "Loading Game…";
    default:
      return "";
  }
};

const Placeholder = ({ type }: Props) => {
  const text = getText(type);
  return <div className={classnames("flex-center", "invalid")}>{text}</div>;
};

export default Placeholder;
